import { usePluginConfig } from "../contexts/pluginContext";

export const useAddEventUrl = ({ utmSource, utmMedium, utmCampaign } = {}) => {
	const { publisherSettings } = usePluginConfig();

	// TODO: Discuss how to integrate utm params here
	const customUrl = publisherSettings?.publisher?.event_submission_url;

	if (customUrl) {
		return customUrl;
	}

	const params = new URLSearchParams({
		partner: publisherSettings?.api_key,
		publisher_id: publisherSettings?.publisher?.id,
	});

	if (utmSource) params.set("utm_source", utmSource);
	if (utmMedium) params.set("utm_medium", utmMedium);
	if (utmCampaign) params.set("utm_campaign", utmCampaign);

	return `${process.env.EVVNT_FORM_URL}?${params.toString()}`;
};
